import React from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../shared/store/views/entityView";
import { scheduleBoardMessagesQuery } from "../../../shared/utils/entitiesFiltersUtils";
import { getHomeroomClassDisplayString } from "../../../shared/utils/utils";
import Popup from "../../../shared/components/ui/popup/Popup";
import HeaderPopup from "../../../shared/components/ui/popup/headerPopup/HeaderPopup";
import ContentsPopup from "../../../shared/components/ui/popup/contentPopup/ContentPopup";
import ScheduleViewBody from "../../../shared/components/features/scheduleSystem/scheduleViewBody/ScheduleViewBody";
import classes from "./SchedulePopup.module.css";

const SchedulePopup = ({ onClose}) => {

    const { texts } = useSelector((state) => state.translate);
    const { userDetails } = useSelector((state) => state.auth);
    const mainClasses = userDetails?.defaultSchool?.mainClasses || [];
    const scheduleEntities = useSelector((state) => selectEntitiesByFilters(state, scheduleBoardMessagesQuery));

    return (
        <Popup close={onClose} title={`${texts.scheduleMiniTitle ?? ""} ${scheduleEntities?.length > 0 ? getHomeroomClassDisplayString(mainClasses[0], texts) : ""}`} dropClass={classes.BackdropPopupClass} dropClassClose={classes.DropClassClose}>
            <HeaderPopup className={classes.HeaderPopup}>
            <p className={classes.Title}>{`${texts.scheduleMiniTitle ?? ""} ${scheduleEntities?.length > 0 ? getHomeroomClassDisplayString(mainClasses[0], texts) : ""}`}</p>
            </HeaderPopup>
            <ContentsPopup className={classes.ContentsPopup} scrollDropClass={classes.SchedulePopupScroll} scrollContentClass={classes.SchedulePopupScrollContent}>
                <ScheduleViewBody scheduleEntities={scheduleEntities} canEdit={false}/>
            </ContentsPopup>
        </Popup>
    );
};
export default SchedulePopup;